export const SEO_LANDING_SLUGS = new Set([
  'real-estate-crm-australia',
  'real-estate-crm-sydney',
  'crm-for-real-estate-agencies',
  'open-house-management-software',
  'workflow-estate-vs-agentbox',
]);

export const NON_AGENCY_SINGLE_SEGMENT_ROUTES = new Set([
  'login',
  'individual',
  'admin',
  'register',
  'privacy',
  'terms',
  'support',
  'plans',
  'demo',
  'checkin',
  'vendor',
  'jobs',
  'contractor',
  'set-password',
  'reset-password',
  'delete-account',
  ...SEO_LANDING_SLUGS,
]);
